module.exports = "https://coinrabbit.io/_next/static/images/no-rewards-0e06e2d8e6def89f95967df0e4b94d41.svg";